import React, { Component } from "react";
import { geoMercator, geoPath } from "d3-geo";
import { geoEckert3 } from "d3-geo-projection";
import { easeQuadOut } from "d3-ease";
import { feature } from "topojson-client";
import throttle from "react-throttle-render";
import world from "data/world.json";
import Background from "components/map/background";
import DataMap from "components/map/datamap";
import GroupedMap from "components/map/groupedMap";
import "./style.css";

class Map extends Component {
  constructor(props) {
    super(props);

    this.elems = {};
    this.calculateData = this.calculateData.bind(this);
    this.project = geoPath().projection(this.projection());

    this.state = {
      countries: feature(world, world.objects.countries).features,
      land: feature(world, world.objects.land).features,
    };
  }

  calculateData(data) {
    const byYear = this.state.countries.reduce((obj, d) => {
      if (d.id === "010" || !data[d.id]) {
        return obj;
      }

      const { yearEnded } = data[d.id];
      const yearly = obj[yearEnded] ? [...obj[yearEnded], d.id] : [d.id];
      return {
        ...obj,
        [yearEnded]: yearly,
      };
    }, {});

    const byYearGMO = this.state.countries.reduce((obj, d) => {
      if (d.id === "010" || !data[d.id]) {
        return obj;
      }

      const { yearEndedWithoutGMO } = data[d.id];
      const yearly = obj[yearEndedWithoutGMO]
        ? [...obj[yearEndedWithoutGMO], d.id]
        : [d.id];
      return {
        ...obj,
        [yearEndedWithoutGMO]: yearly,
      };
    }, {});

    return this.state.countries
      .map(d => {
        if (d.id === "010" || !data[d.id]) {
          return;
        }

        const { hasEnded, yearEnded, yearEndedWithoutGMO } = data[d.id];
        const path = this.project(d);
        const center = this.project.centroid(d);
        const start = { x: center[0], y: center[1] };
        const end = {
          x: 1780 / 45 * (yearEnded - 2015) + 1,
          y:
            780 -
            byYear[yearEnded].indexOf(d.id) * 10 +
            byYear[yearEnded].length * 10 / 2 -
            7,
        };

        const endGMO = {
          x: 1780 / 45 * (yearEndedWithoutGMO - 2015) + 1,
          y:
            780 -
            byYearGMO[yearEndedWithoutGMO].indexOf(d.id) * 10 +
            byYearGMO[yearEndedWithoutGMO].length * 10 / 2 -
            7,
        };

        return {
          id: d.id,
          path,
          yearEnded,
          yearEndedWithoutGMO,
          updatesWithGMO: yearEnded !== yearEndedWithoutGMO,
          hasEnded,
          fill: hasEnded ? "transparent" : "#FFAF3E",
          circleColor: !hasEnded ? "transparent" : "#FFAF3E",
          index: byYear[yearEnded].indexOf(d.id),
          indexGMO: byYearGMO[yearEndedWithoutGMO].indexOf(d.id),
          start,
          end,
          endGMO,
          center: {
            x: hasEnded ? end.x : start.x,
            y: hasEnded ? end.y : start.y,
          },
        };
      })
      .filter(Boolean)
      .filter(({ yearEnded }) => yearEnded >= 2015)
      .sort((a, b) => {
        if (a.yearEnded === b.yearEnded) {
          return a.index - b.index;
        } else {
          return a.yearEnded - b.yearEnded;
        }
      });
  }

  projection() {
    return geoEckert3()
      .scale(360)
      .translate([1780 / 2 - 50, 720 / 2 + 40]);
  }

  render() {
    const { countries, land } = this.state;
    const { data, goingForwards } = this.props;
    const calculatedData = this.calculateData(data);

    return (
      <div className="map">
        <div className="map__bg">
          <DataMap project={this.project} data={calculatedData} />
        </div>

        {/* <div className="map__bg">
          <GroupedMap
            project={this.project}
            data={calculatedData}
            land={land}
            countries={countries}
          />
        </div> */}
      </div>
    );
  }
}

export default throttle(100)(Map);



// WEBPACK FOOTER //
// ./src/components/map/index.js